import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/leadFunctions/leadEstimateActions'
import { fetchLeadDetails } from '../leadDetails'
import * as api from '../../api/lead/estimates'

export function* leadEstimatesRefresh(action) {
  try {
    const payload = yield call(api.getLeadEstimates, action.leadId)
    yield put({ type: constants.LEAD_ESTIMATES_REFRESH.SUCCESS, payload })

    action.next && action.next(null, payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_ESTIMATES_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchLeadEstimates() {
  yield takeLatest(constants.LEAD_ESTIMATES_REFRESH.ACTION, leadEstimatesRefresh)
}

function* sagaCreateLeadEstimate(action) {
  try {
    const payload = {
      content: action.content,
      estimateSections: action.estimateSections,
      leadId: action.leadId,
      userId: action.userId
    }
    yield call(api.createLeadEstimate, payload)
    yield put({ type: constants.LEAD_ESTIMATE_CREATE.SUCCESS, payload })
    yield call(leadEstimatesRefresh, { leadId: payload.leadId })
    yield call(fetchLeadDetails, { leadId: payload.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_ESTIMATE_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateLeadEstimate() {
  yield takeLatest(constants.LEAD_ESTIMATE_CREATE.ACTION, sagaCreateLeadEstimate)
}

function* sagaUpdateLeadEstimate(action) {
  try {
    const payload = {
      estimateId: action.estimateId,
      content: action.content,
      estimateSections: action.estimateSections,
      leadId: action.leadId,
      userId: action.userId
    }
    yield call(api.updateLeadEstimate, payload)
    yield put({ type: constants.LEAD_ESTIMATE_UPDATE.SUCCESS, payload })
    yield call(leadEstimatesRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: payload.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_ESTIMATE_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateLeadEstimate() {
  yield takeLatest(constants.LEAD_ESTIMATE_UPDATE.ACTION, sagaUpdateLeadEstimate)
}

function* sagaDeleteLeadEstimate(action) {
  try {
    const payload = {
      estimate_id: action.estimateId,
      leadId: action.leadId
    }
    yield call(api.deleteLeadEstimate, payload)
    yield put({ type: constants.LEAD_ESTIMATE_DELETE.SUCCESS, payload })
    yield call(leadEstimatesRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: payload.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_ESTIMATE_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteLeadEstimate() {
  yield takeLatest(constants.LEAD_ESTIMATE_DELETE.ACTION, sagaDeleteLeadEstimate)
}

function* getEstimateSections(action) {
  try {
    const payload = yield call(api.getEstimateSections, action.estimateId)
    yield put({ type: constants.GET_LEAD_ESTIMATE_SECTIONS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_LEAD_ESTIMATE_SECTIONS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetEstimateSections() {
  yield takeLatest(constants.GET_LEAD_ESTIMATE_SECTIONS.ACTION, getEstimateSections)
}

function* getEstimateItems(action) {
  try {
    const payload = yield call(api.getEstimateItems, action.estimateId)
    yield put({ type: constants.GET_LEAD_ESTIMATE_ITEMS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_LEAD_ESTIMATE_ITEMS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetEstimateItems() {
  yield takeLatest(constants.GET_LEAD_ESTIMATE_ITEMS.ACTION, getEstimateItems)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchLeadEstimates),

    fork(watchCreateLeadEstimate),
    fork(watchUpdateLeadEstimate),
    fork(watchDeleteLeadEstimate),

    fork(watchGetEstimateSections),
    fork(watchGetEstimateItems)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/leadFunctions/leadEstimateSaga.js